module.exports = __webpack_public_path__ + "static/media/cross.faf0f393.svg";